import Modal from 'flarum/common/components/Modal';
export default class SafariModalHack extends Modal {
  className() {
    return 'LoadingModal Modal--small';
  }
  title() {
    return this.attrs.title;
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.$('.CommandButton').on('click', () => {
      app.modal.close();
    });
  }
  content() {
    const onsubmit = this.attrs.onsubmit ? this.attrs.onsubmit.bind(this) : () => {};
    return m("div", {
      className: "Modal-body"
    }, m("form", {
      className: "Form",
      onsubmit: onsubmit
    }, this.attrs.vnodeContent));
  }
}
flarum.reg.add('bizkaitarra-aurrera-editor', 'common/components/SafariModalHack', SafariModalHack);